import { ActionType } from "./actions";
import { IFilter } from "../../../classes/filter";
import { MediaGalleryAppState } from "../../../classes/index";
import { Dispatch } from "react-redux";
import { storeFilteredMedia } from "./media-api";
import { IMediaGalleryItem } from "../../../classes/media-gallery";

/**
 * Dispatch this function to open the modal.
 */
export function openModal() {
    return {
        type: ActionType.OPEN_MODAL
    }
}

/**
 * Dispatch this action to set the modal state to closed.
 */
export function closeModal() {
    return {
        type: ActionType.CLOSE_MODAL
    }
}

/**
 * The modal will now have this content.
 * @param content
 */
export function setModalContent(content: IMediaGalleryItem) {
    return {
        type: ActionType.SET_MODAL_CONTENT,
        value: content
    }
}


// WEBPACK FOOTER //
// ./app/media-gallery/redux/actions/modal.ts